import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getJob } from "./fetchJobApi";

const initialState = {
  job: {},
  isLoading: false,
  isError: false,
  error: "",
};

// thunks
// fetch job thunk...
export const fetchJob = createAsyncThunk("job/fetchJob", async (id) => {
  const response = await getJob(id);
  return response;
});

// slice
const fetchjobSlice = createSlice({
  name: "fetchjobSlice",
  initialState,
  //   reducers: {},
  extraReducers: (builder) => {
    // fetchjob ...
    builder.addCase(fetchJob.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
      state.error = "";
    });
    builder.addCase(fetchJob.fulfilled, (state, action) => {
      state.isLoading = false;
      state.job = action.payload;
    });
    builder.addCase(fetchJob.rejected, (state, action) => {
      state.isError = true;
      state.error = action.error?.message;
      state.job = {};
      state.isLoading = false;
    });
  },
});

export default fetchjobSlice.reducer;
